import styled, { css } from 'styled-components';
import { token } from '@zillow/constellation';

import InteractiveCard from '../../../InteractiveCard';

import MESSAGE_MODULE_TYPES from '../../MESSAGE_MODULE_TYPES';

export const StyledCard = styled(InteractiveCard)`
  margin-top: 0px;
  box-shadow: none;

  ${(props) => {
    // @ts-expect-error
    if (props.type === MESSAGE_MODULE_TYPES.WARNING) {
      return css`
        background-color: ${token('colors.backgroundRed')};
      `;
    }

    return css`
      background-color: ${token('colors.backgroundGreen')};
    `;
  }}
`;
